import { useTranslation } from 'react-i18next';

export function useTranslationUtils () {
    const { t } = useTranslation();

    // Translate a token that translates to a string with substitution params and the params
    // are provided as a javascript object in 'args'
    const tp = function(token, args) {
        var translation = t(token);

        for (var property in args) {
            var search = `[[${property}]]`;

            translation = translation.replace(search, args[property]);
        }

        return translation;
    }

    // Translate a string that contains a key and potentially named parameters inline by
    // looking up a translation that potentially includes substitution params
    //
    // so input string,
    //      Warnings.Process.L3LabMismatch[[value=1.00,l3value=0.91,quality=Melt Index]]
    // becomes
    //      Warnings.Process.L3LabMismatch and {value=1.00||l3value=0.91||quality=Melt Index}
    // then we can call
    //      tp()
    //
    //  Note, this function has been extended to allow for multiple token sets to be in the same string, e.g.
    //
    //    Warnings.Review.SiloGradingRule5Percent[[percentage=8.60||quality=Irganox 1076||weight=239.42||silo=5180BN001]]
    //    - Warnings.Review.SiloGradingRuleBatchComment[[percentage=8.00||weight=27.08||SiteCollectionID=F00010A_5101_0]]
    //    - Warnings.Review.SiloGradingRuleBatchComment[[percentage=13.92||weight=85.58||SiteCollectionID=F00010A_5101_1]]
    //
    //  To do this after finding the replacement args between [[ and ]], we work backwards to find the beginning of the token
    //  then replace that part in the string using the translation logic. We repeat this until we find no more [[ ]]
    const ts = function (tokenAndArgs) {

        while (true) {
            var argStart = tokenAndArgs.indexOf("[[");
            var argEnd = tokenAndArgs.indexOf("]]");

            if (argStart === -1) {
                // tokenAndArgs doesn't contain any args (any more), so we're done..
                return tokenAndArgs;
            }

            var tokenStartsAt = findTokenStart(tokenAndArgs, argStart - 1);

            var part = tokenAndArgs.substring(tokenStartsAt, argEnd);
            var translatedPart = translatePart(part, argStart - tokenStartsAt, argEnd - tokenStartsAt);

            var newTokenAndArgs = (tokenStartsAt > 0) ? tokenAndArgs.substring(0, tokenStartsAt - 1) : "";
            newTokenAndArgs += translatedPart;
            newTokenAndArgs += tokenAndArgs.substring(argEnd + 2);

            tokenAndArgs = newTokenAndArgs;
        }
    }

    // Return the index in searchString where the token starts, working backwards from startPosition
    // We assume that tokens are made from alphanumeric characters and '.' only
    const findTokenStart = function(searchString, argStartPosition)
    {
        // Characters that might be in token strings
        const tokenChars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789.";
        var pos = argStartPosition;

        while (pos >= 0) {
            if (tokenChars.indexOf(searchString[pos]) === -1) {
                // Character at 'pos' isn't in a token. So pos+1 is the last character that we found that was in the token
                return pos + 1;
            }

            pos--;
        }

        return 0;
    }

    // Translate a string that contains a key and potentially named parameters inline by
    // looking up a translation that potentially includes substitution params
    //
    // so input string,
    //      Warnings.Process.L3LabMismatch[[value=1.00,l3value=0.91,quality=Melt Index]]
    // becomes
    //      Warnings.Process.L3LabMismatch and {value=1.00||l3value=0.91||quality=Melt Index}
    // then we can call
    //      tp()
    const translatePart = function (tokenAndArgs, argStart, argEnd) {
        var token = tokenAndArgs.substr(0, argStart);

        if ((argStart + 2) === argEnd) {
            // empty substitution arguments, so we just have a token
            return t(token);
        }

        var argList = tokenAndArgs.substring(argStart + 2, argEnd);

        var allKeyValues = argList.split("||"); // So, || is the separator between substitution arguments in the message string

        // Build the args object by looking at the keys & values in the arguments list
        var args = {};

        for (var idx = 0; idx < allKeyValues.length; idx++) {

            var equalsPos = allKeyValues[idx].indexOf("="); // Not using split as the value itself my contain =, so we only care about the first equals

            var key = allKeyValues[idx].substr(0, equalsPos);
            var value = allKeyValues[idx].substring(equalsPos + 1);

            args[key] = value;
        }

        return tp(token, args);
    }

    return { tp, ts }
}
